import React from 'react';

export const requirementFilterExtension: {
  id: string;
  Component: React.ComponentType<any>;
}[] = [];
